import React from 'react';
import jspdf from 'jspdf';
import { Provider } from 'react-redux';
import { MAIN_MAP } from '../../../../redux/map/Constants';
import withStyles from '@material-ui/core/styles/withStyles';
import html2canvas from 'html2canvas';
import { Typography } from '@material-ui/core';
import { CompassIcon } from './Icons';
import LegendItem from '../../../panels/LegendItem';

import ThemeProvider from '@material-ui/styles/ThemeProvider';
import { lightTheme, darkTheme } from '../../../../Config/theme';
import store from '../../../../redux/Store';
import SiteCardLegendItem from '../../../panels/SiteCardLegendItem.jsx';

const toPixels = (length) => {
    return ((96 / 25.4) * length) + 'px';
};

class PDFTemplate extends React.Component {
    constructor (props) {
        super(props);
        this.pdf = new jspdf({
            orientation: 'l',
            unit: 'mm',
            format: this.props.formData.paper,
            compress: true
        }),
        this.calcMapDimensions = this.calcMapDimensions.bind(this);
    }

    componentDidMount () {
        const { formData, stopDownloading } = this.props;
        const template = document.getElementById('pdf-template');
        if (template) {
            html2canvas(template, {
                scale: 2
            }).then((canvas) => {
                // get minimap image here
                this.pdf.addImage(
                    canvas.toDataURL(),
                    'png', 0, 0,
                    this.pdf.internal.pageSize.width,
                    this.pdf.internal.pageSize.height
                );
                this.pdf.setProperties({
                    title: formData.title,
                    subject: formData.subtitle,
                    creator: formData.author,
                    author: `${formData.author} With LandHawk, Mapbox & Mastermap` // Should also include map/data copyright here
                });
                this.pdf.save(
                    `${formData.title}.pdf`,
                    { returnPromise: true }
                ).then((value) => {
                    stopDownloading();
                }).catch((reason) => {
                    console.error(reason);
                    stopDownloading();
                });

            })
                .catch(err => {
                    console.error(err.message);
                    stopDownloading();
                });
        }
    }

    calcMapDimensions () {
        let height = this.pdf.internal.pageSize.height;
        let width = this.pdf.internal.pageSize.width;
        let margin = 5;
        let content_width = 65;
        let content_left = width - margin - content_width;
        let map_width = content_left - margin - 2;
        let map_height = height - (margin * 2);
        return {
            map_width,
            map_height
        };
    }

    render () {
        const {
            classes,
            mapImage,
            minimapImage,
            formData
        } = this.props;

        let unitsValue = parseInt(formData.scale) * 0.001 * 20;
        let unitsText = 'm';
        if (unitsValue / 1000 > 1) {
            unitsValue /= 1000;
            unitsText = 'km';
        }
        const { map_width, map_height } = this.calcMapDimensions();


        // ToDo define this somewhere else with the rest of the layer settings
        const redLineBoundaryLayer = {
            styles: [
                {
                    legendSpecification: [{
                        type: 'fill',
                        color: '#fff',
                        label: 'Red Line Boundary',
                        borderColor: 'red',
                        borderWidth: 2
                    }]
                }
            ],
            name: 'Red Line Boundary'
        };

        // Have direct access to redux store state, have to do like this other need to wrap in a parent element with Provider instead of inline here
        const state = store.getState();
        const llayers = state.activeLayers
            .filter(l => l.printable)
            .reverse()
            .map(activeLayer => ({
                ...activeLayer,
                ...state.layers.layers.find((layer) => layer.system_name === activeLayer.uid),
                ...state.layerSettingsReducer.find((settings) => settings.uid === activeLayer.uid)
            }))
            .sort((a, b) => LegendItem.isCollapsible(a.styles[a.currentStyleIdx || 0].legendSpecification) - LegendItem.isCollapsible(b.styles[b.currentStyleIdx || 0].legendSpecification));

        const layers = llayers;
        const baseLayer = state.layers.baseLayers.find(l => l.system_name === formData.basemap);
        const selectedDrawnFeatures = state[MAIN_MAP].drawModule ? state[MAIN_MAP].drawModule.getDrawControl().getSelected().features : [];

        const project = state.project.currentProject;
        const siteCards = state.siteCard.siteCards;
        const siteCardsVisible = state.siteCard.areSiteCardsVisible;

        console.log('sitecard forms ', project?.numSiteCards );
        console.log('sitecard forms 2', siteCardsVisible );
        console.log('sitecard forms 3', formData.mySiteCardsVisible);


        return (

            <div className={classes.hidden}>
                <div className={`${classes.root} ${classes.border}`} id="pdf-template" style={{
                    width: toPixels(this.pdf.internal.pageSize.width),
                    height: toPixels(this.pdf.internal.pageSize.height)
                }}>
                    <div className={classes.mapImageContainer}>
                        <div className={classes.mainmap}>
                            <div className={classes.mapImage} style={{
                                width: toPixels(map_width),
                                height: toPixels(map_height),
                                backgroundImage: `url('${mapImage}')`
                            }}>
                                <div className={classes.footer}>
                                    <div className={formData.paper !== 'a5' ? classes.footerLeft : classes.footerLeftMini}>
                                        <div className={formData.paper !== 'a5' ? classes.miniLogo : classes.miniLogoWithoutText}></div>
                                        <div className={classes.footerLeftText}>
                                            <strong>Powered by LandHawk</strong>
                                            {baseLayer.license && <span className={classes.spacer}>|</span>}{baseLayer.license}
                                            { layers.length > 0 && <span className={classes.spacer}>|</span> }
                                            { layers.map(l => l.license)
                                                .filter((v, i, self) => self.indexOf(v) === i).join(' | ')
                                            }
                                            <span className={classes.spacer}>|</span>
                                                    OS 0100057808
                                            <span className={classes.spacer}>|</span>
                                                    NOT TO BE USED FOR NAVIGATION
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classes.rightSidebars}>
                        <div className={`${classes.border} ${classes.flexColumn} ${classes.rightTop}`}>
                            <div className={classes.title}>
                                {formData.title}
                            </div>
                            <div className={classes.subtitle}>
                                {formData.subtitle}
                            </div>
                            <div className={`${classes.legend} ${classes.flexGrow}`}>
                                { formData.redLineBoundaryVisible && selectedDrawnFeatures.length > 0 && (
                                    <LegendItem layer={redLineBoundaryLayer} isStatic />
                                ) }
                                {
                                    formData.mySiteCardsVisible && siteCardsVisible && project?.numSiteCards > 0 && <SiteCardLegendItem project={project} isStatic />
                                }
                                { layers.map((l, i) => <LegendItem key={i} layer={l} isStatic /> ) }
                            </div>
                            <div className={classes.minimap}>
                                <img src={minimapImage} className={classes.minimapImage} />
                            </div>
                        </div>
                        <div className={`${classes.border} ${classes.rightBottom}`}>
                            <div className={classes.table}>
                                <div className={classes.equalRow}>
                                    <div className={classes.cell}><strong>Reference:</strong> {formData.reference ? formData.reference : 'No reference'}</div>
                                    <div className={classes.cell}><strong>Date:</strong> {formData.date}</div>
                                </div>
                                <div className={classes.equalRow}>
                                    <div className={classes.cell}><strong>Author:</strong> {formData.author}</div>
                                    <div className={classes.cell}><strong>Check:</strong> {formData.check}</div>
                                </div>
                                <div className={classes.equalRow}>
                                    <div className={classes.cell}><strong>Scale:</strong> 1:{formData.scale}</div>
                                    <div className={classes.cell}><strong>EPSG:</strong> 3857</div>
                                </div>
                            </div>
                            <div className={`${classes.scaleRow} ${formData.clientLogo || formData.companyLogo ? classes.scaleRowBorder : ''}`}>
                                <div className={classes.center}>
                                    <div className={classes.scaleContainer}>
                                        <div className={classes.scaleLabels}>
                                            <div className={classes.scaleLabel}>0</div>
                                            <div className={classes.scaleLabel}>{unitsValue}</div>
                                            <div className={classes.scaleLabel}>{unitsValue * 2 + unitsText}</div>
                                        </div>
                                        <div className={`${classes.scale} ${classes.border}`}>
                                            <div className={classes.black}></div>
                                            <div className={classes.white}></div>
                                            <div className={classes.black}></div>
                                            <div className={classes.white}></div>
                                        </div>
                                        <div className={classes.scaledForPrintText}>SCALED FOR PRINT AT {formData.paper.toUpperCase()} ONLY</div>
                                        <div className={classes.scaleDescription}>
                                                    Do not scale this drawing. {formData.author} to be notified of any discrepancies in this drawing. This drawing is copyright.
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.compassContainer}>
                                    <CompassIcon className={classes.northImage} />
                                </div>
                            </div>
                            { formData.clientLogo && <div className={`${classes.userImageContainer} ${formData.clientLogo && formData.companyLogo ? classes.scaleRowBorder : ''}`}>
                                <img src={formData.clientLogo} className={classes.userImage} />
                            </div> }
                            { formData.companyLogo && <div className={classes.userImageContainer}>
                                <img src={formData.companyLogo} className={classes.userImage} />
                            </div> }
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const styles = (theme) => ({
    root: {
        display: 'grid',
        gridTemplateColumns: 'auto 246px',
        padding: '19px',
        fontSize: '9px',
        boxSizing: 'border-box',
        color: theme.palette.text.primary,
        fontFamily: 'Helvetica, Arial, sans-serif',
        backgroundColor: theme.palette.background.paper
    },
    rightSidebars: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    mainmap: {
        width: '100%',
        height: '100%'
    },
    border: {
        border: '1px solid ' + theme.palette.text.primary
    },
    mapImage: {
        border: '1px solid ' + theme.palette.text.primary,
        // backgroundSize: 'contain',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        display: 'flex',
        alignItems: 'flex-end'
    },
    flexGrow: {
        flexGrow: 1
    },
    title: {
        width: '100%',
        height: '50px',
        display: 'grid',
        placeItems: 'center',
        fontSize: '20px',
        fontWeight: 600,
        borderBottom: '1px solid ' + theme.palette.text.primary
    },
    subtitle: {
        width: '100%',
        height: '30px',
        display: 'grid',
        placeItems: 'center',
        fontSize: '14px',
        fontWeight: 600,
        borderBottom: '1px solid ' + theme.palette.text.primary
    },
    rightTop: {
        // height: '465.7854068241469px',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        marginBottom: '5px'
    },
    equalRow: {
        display: 'grid',
        gridTemplateColumns: '50% 50%',
        borderBottom: '1px solid ' + theme.palette.text.primary
    },
    cell: {
        padding: '10px 5px',
        fontSize: '9px',
        '&:nth-child(2)': {
            borderLeft: '1px solid ' + theme.palette.text.primary
        }
    },
    scaleRow: {
        display: 'grid',
        gridTemplateColumns: 'auto 50px',
        borderBottom: '1px solid ' + theme.palette.text.primary
    },
    scaleRowBorder: {
        borderBottom: '1px solid ' + theme.palette.text.primary
    },
    scale: {
        display: 'flex',
        width: '151.18110236220474px',
        margin: '0 auto',
        boxSizing: 'border-box',
        '& > div': {
            width: 'calc(151.18110236220474px / 4)',
            height: '5px'
        }
    },
    black: {
        backgroundColor: theme.palette.text.primary
    },
    white: {
        backgroundColor: '#ffffff'
    },
    scaleContainer: {
        padding: '10px 5px'
    },
    scaleLabels: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '153.18110236220474px',
        margin: '0 auto'
    },
    scaleLabel: {
        width: '10px'
    },
    scaleDescription: {
        textAlign: 'center'
    },
    compassContainer: {
        textAlign: 'center',
        borderLeft: '1px solid ' + theme.palette.text.primary,
        display: 'grid',
        placeItems: 'center'
    },
    northImage: {
        // height: '70px',
        // verticalAlign: 'middle'
    },
    landhawkImageContainer: {
        textAlign: 'center',
        borderTop: '1px solid ' + theme.palette.text.primary,
        padding: '5px 0'
    },
    landhawkImage: {
        height: '30px',
        verticalAlign: 'middle'
    },
    userImageContainer: {
        display: 'grid',
        placeItems: 'center',
        height: '75px'
    },
    userImage: {
        maxHeight: '55px',
        maxWidth: '240px',
        padding: '5px 0'
    },
    minimap: {
        borderTop: '1px solid ' + theme.palette.text.primary
    },
    footer: {
    },
    legend: {
        fontSize: '14px',
        display: 'flex',
        flexDirection: 'column',
        padding: '10px 0',
        '&> *:not(:last-child)': {
            marginBottom: 10
        }
    },
    redLineBoundary: {
        display: 'flex',
        /* justify-content: space-between; */
        alignItems: 'center',
        columnGap: '10px',
        paddingLeft: '10px',
        paddingTop: '20px'
    },
    redOutline: {
        border: '2px solid red',
        height: '15px',
        width: '30px'
    },
    hidden: {
        overflow: 'hidden',
        height: 0,
        width: 0,
        position: 'fixed'
    },
    legendItem: {
        width: '100%',
        paddingTop: '20px'
    },
    legendItemTitle: {
        paddingLeft: '10px',
        paddingBottom: '10px',
        fontSize: '14px',
        fontWeight: 600
    },
    redLineBoundaryTitle: {
        fontSize: '14px',
        fontWeight: 600
    },
    divider: {
        width: '100%',
        borderTop: '1px solid #888888'
    },
    minimapImage: {
        width: '100%'
    },
    miniLogo: {
        backgroundColor: theme.palette.text.primary,
        height: '25px',
        width: '100px',
        backgroundImage: 'url(\'/img/printout/lh-logo-mini.png\')',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center'
    },
    footerLeft: {
        display: 'flex',
        alignItems: 'flex-end'
    },
    footerLeftMini: {
        display: 'grid',
        alignItems: 'flex-end',
        gridTemplateColumns: '30px auto'
    },
    footerLeftText: {
        display: 'inline',
        padding: '5px 2px',
        backgroundColor: theme.palette.secondary.light + 'BF'
    },
    spacer: {
        padding: '0 5px'
    },
    scaledForPrintText: {
        padding: '10px 0 5px 0',
        textAlign: 'center'
    },
    miniLogoWithoutText: {
        backgroundColor: theme.palette.text.primary,
        height: '30px',
        width: '30px',
        padding: '2px',
        boxSizing: 'border-box',
        backgroundImage: 'url(\'/img/printout/landhawk-logo-icon.png\')',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center'
    }
});

export default withStyles(styles)(PDFTemplate);